import { AllPeriodsLimitType, Limit, LimiteGeralModel, LimitePrazoCompensacao, LimitTipo } from './../../limits/models/limits';
import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TransfersOtherBanksEventType } from '../transfers-other-banks.event.type';
import { TweenMax, Quint } from 'gsap';
import { Transfer } from '../../models/transfer';
import { EventTypes } from '../../../shared/EventTypes';
import { TransfersOtherBanksService } from '../transfers-other-banks.service';
import { Auth } from '../../../autentication/Auth';
import { MatDialog } from '@angular/material';
import { PixHelpComponent } from '../../pix/help/help.component';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { Util } from '../../../utils/util';
import { Router } from '@angular/router';
import { TedLimitModel, LimiteTransferType } from '../models/tedLimitModel';
import { TransferType } from '../models/transferType.enum';
import { LimiteTipoPeriodo } from '../../payment-securities/models/payment-limits-v2';


@Component({
	selector: 'app-transfer-type',
	templateUrl: './transfer-type.component.html',
	styleUrls: ['./transfer-type.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransferTypeComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public form: FormGroup;
	private today: number = Date.now();
	private view = '[data-component="transfer-type"]';

	dataLimits: Array<AllPeriodsLimitType>;

	active = false;
	private scheduleError = false;
	accountType = Auth.getInstance().getUser().accountType;


	constructor(
		private formBuilder: FormBuilder,
		private transferOBService: TransfersOtherBanksService,
		public dialog: MatDialog,
		private router: Router
	) {

		this.form = formBuilder.group({
			'transferType': ['TED', Validators.required]
		});

	}

	ngOnInit() {
		AppEventDispatcher.listen(TransfersOtherBanksEventType.STEPS.TRANSFER_TYPE, data => {

			if (data.show) {
				this.setForm.emit(this.form);
				this.active = true;
				this.loadLimits();
			} else {
				this.hide();
			}
		});
	}

	loadLimits() {
		this.preload(true);

		this.transferOBService.getDataLimits().subscribe((data: AllPeriodsLimitType[]) => {
			data = data.filter((e) => {
				if (e !== undefined && e.type === LimitTipo.TED) {
					return e
				}
			});

			this.dataLimits = data.reverse();

			this.getTedMaxTransactionValue();
			this.show();
			this.preload(false);

		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.STEPS.TRANSFER_TYPE);
	}

	getLimitTitle(limit) {
		switch (limit.typeLimit) {
			case LimiteTipoPeriodo.TED_DIURNO:
			case LimiteTipoPeriodo.TED_NOTURNO:
				return 'TED';
			case LimiteTipoPeriodo.BOLETO_DIURNO:
			case LimiteTipoPeriodo.BOLETO_NOTURNO:
				return "Boleto";
			case LimiteTipoPeriodo.TEF_DIURNO:
			case LimiteTipoPeriodo.TEF_NOTURNO:
				return "TEF";
			default:
				limit.typeLimit;
		}

	}

	limitAmountPerDay(limit: LimiteGeralModel) {
		const limitAmount = limit.LimitarValorPorDia;
		if (limitAmount) return limit.ValorPorDia;
		return "Ilimitado"
	}

	showTime(limit: LimiteGeralModel) {
		const startTime = limit.FaixaHorario.HorarioInicial;
		const endTime = limit.FaixaHorario.HorarioFinal;

		return `(${startTime} - ${endTime})`
	}

	getLimitCompensationDate(limit: AllPeriodsLimitType) {
		const compensationDailyDate = limit.dailyLimit.FaixaHorario.PrazoCompensacao;
		const compensationNightlyLimitDate = limit.nightlyLimit.FaixaHorario.PrazoCompensacao;

		if (compensationDailyDate === LimitePrazoCompensacao.MESMO_DIA_UTIL || compensationNightlyLimitDate === LimitePrazoCompensacao.MESMO_DIA_UTIL) {
			return 'Mesmo dia*';
		} else if (compensationDailyDate === LimitePrazoCompensacao.PROXIMO_DIA_UTIL || compensationNightlyLimitDate === LimitePrazoCompensacao.PROXIMO_DIA_UTIL) {
			return 'Próximo dia útil*';
		} else {
			return compensationDailyDate + ' dias úteis';
		}
	}

	setTransferData() {
		this.transferData.transferType = this.form.controls.transferType.value;
	}

	show() {

		TweenMax.delayedCall(.5, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
			this.showBalanceChange.emit(false);
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .1, left: 0, ease: Quint.easeOut });

		});

	}

	hide() {
		this.setTransferData();

		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});

	}


	public openHelpModal(): void {
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay });
	}

	getTedMaxTransactionValue() {
		const FP = new FormatPricePipe();

		this.transferOBService.getTEDLimit().subscribe((data) => {

			const dataTed = Util.keysToCamel(data.Retorno) as TedLimitModel[];
			const tedIndex = this.dataLimits.findIndex((obj => obj.type === TransferType.TED));
			const tedLimit = dataTed.find(e => e.tipo === LimiteTransferType.TED_DIURNO);
			this.dataLimits[tedIndex].dailyLimit.ValorMaximoPorTransacao = FP.transform(tedLimit.valorPorDia, false);

			this.show();
			this.preload(false);

		},
			(error) => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			}
		);
	}
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfer-type/transfer-type.component.ts